// test2065
(2065 && 0);
